module.exports = __webpack_public_path__ + "img/das.e761273e.jpg";